import { DocumentNode, gql } from '@apollo/client';
import { DatabaseIconFragmentGql } from './DatabaseIconFragmentGql';
import { DatabaseServerOrPathFragmentGql } from './DatabaseServerOrPathFragmentGql';
import { LabelFragment } from './LabelFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';
import { TagsFragmentGql } from './TagsFragment';

export const DatabasesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment DatabasesDisplayGridRowData on Database {
  id
  name
  description
  connectionType
  luid
  vizportalId
  isGrouped
  isEmbedded
  ...Tags
  contact {
    ...TableauUser
  }
  controlledPermissionsEnabled: isControlledPermissionsEnabled
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ...DatabaseIcon
  ...DatabaseServerOrPath
  labels (filter: {isActive: true}){
    ...Label
  }
}
${TagsFragmentGql}
${DatabaseServerOrPathFragmentGql}
${DatabaseIconFragmentGql}
${TableauUserFragmentGql}
${LabelFragment}
`;
